
(function(){
  function q(sel, ctx){ return (ctx || document).querySelector(sel); }
  function qa(sel, ctx){ return Array.from((ctx || document).querySelectorAll(sel)); }

  function forceQuizLabel(){
    Array.from(document.querySelectorAll('button,a,.nm-quick-btn')).forEach(function(el){
      var t=(el.textContent||'').trim().toLowerCase();
      if (t==='quiz pro' || t==='quizpro' || t==='🧠 quiz pro') el.textContent='🧠 Quiz';
    });
  }

  function syncBranding(){
    var title = qa('.nm-chat-title span').find(function(el){ return (el.textContent || '').trim(); });
    if (title) title.textContent = 'Nootro-Assistant';

    var fabLabel = q('#nmChatFab .nm-fab-label');
    if (fabLabel) fabLabel.textContent = '🧠';

    qa('.nm-quick-btn').forEach(function(btn){
      var txt = (btn.textContent || '').trim();
      if (txt.indexOf('Quiz') !== -1) btn.textContent = '🧠 Quiz';
    });
  }


  function removeNavDuplicateQuiz(){
    var quizNodes = Array.from(document.querySelectorAll('button,a,.nm-quick-btn')).filter(function(el){
      var t = (el.textContent || '').trim().toLowerCase();
      return t === '🧠 quiz' || t === 'quiz' || t === 'quiz pro' || t === 'quizpro';
    });
    if (quizNodes.length > 1){
      quizNodes.slice(1).forEach(function(el){ el.remove(); });
    }
  }

  function ready(fn){

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function(){
    syncBranding();
    removeNavDuplicateQuiz();
    forceQuizLabel();

  });
})();
